package com.milta.core.localization

/**
 * Strings for the Admin "Usage IA" dashboard screen (web-only, Enterprise back-office — see
 * [com.milta.web.AdminOcrAnalysisContent]). Read-only cost-comparison view over the background OCR
 * analysis pipeline.
 */
data class AdminOcrAnalysisStrings(
    val loading: String,
    val errorNoConnection: String,
    val errorGeneric: String,
    val emptyStateMessage: String,
    val kpiTotalDocumentsLabel: String,
    val kpiCompletedDocumentsLabel: String,
    val kpiCompletedDocumentsSubtitle: String,
    val kpiTotalRealCostLabel: String,
    val kpiTotalInputTokensLabel: String,
    val kpiTotalOutputTokensLabel: String,
    /** Composed in code as "fileKindImageLabel: N · fileKindPdfLabel: N · fileKindXlsxLabel: N". */
    val breakdownByFileKindLabel: String,
    val fileKindImageLabel: String,
    val fileKindPdfLabel: String,
    val fileKindXlsxLabel: String,
    val flowTitle: String,
    /** Short decision-branch connector labels for the Mermaid diagram (e.g. "Yes"/"No" on a
     * decision diamond) — kept distinct from any other screen's strings, same self-contained
     * convention as every other *Strings class in this codebase. */
    val flowYesLabel: String,
    val flowNoLabel: String,
    val flowStep1Title: String,
    val flowStep1Subtitle: String,
    val flowStep2Title: String,
    val flowStep2Subtitle: String,
    /** Divergence note from the original POC design — no hash-based duplicate short-circuit exists
     * in this port yet (see ScanDeliveryListHandler's own comment: "Duplicate-skip behavior itself
     * is not wired yet"). Shown inline so the client is never misled into thinking this is live. */
    val flowStep2Note: String,
    val flowStep3Title: String,
    val flowStep3Subtitle: String,
    val flowImageBranchTitle: String,
    val flowImageStep1Title: String,
    val flowImageStep1Subtitle: String,
    val flowImageStep2Title: String,
    val flowImageStep2Subtitle: String,
    val flowImageStep3Title: String,
    val flowImageStep3Subtitle: String,
    val flowImageStep4Title: String,
    val flowImageStep4Subtitle: String,
    val flowImageStep5Title: String,
    val flowImageStep5Subtitle: String,
    val flowPdfBranchTitle: String,
    val flowPdfStep1Title: String,
    val flowPdfStep1Subtitle: String,
    /** Divergence note — a scanned PDF with no native text is NOT re-read as images today (no
     * page-by-page rendering + local OCR pass, unlike the original POC design). */
    val flowPdfNote: String,
    val flowXlsxBranchTitle: String,
    val flowXlsxStep1Title: String,
    val flowXlsxStep1Subtitle: String,
    /** Divergence note — no local quality gate exists for spreadsheets today. */
    val flowXlsxNote: String,
    val flowClaudeTitle: String,
    val flowClaudeSubtitle: String,
    val flowSimulationTitle: String,
    val flowSimulationNote: String,
    val flowPersistTitle: String,
    val flowPersistSubtitle: String,
    val flowDashboardTitle: String,
    val flowDashboardSubtitle: String,
    val tableTitle: String,
    val columnMode: String,
    val columnDocuments: String,
    val columnClaudeCalls: String,
    val columnProjectedCost: String,
    val columnRealCost: String,
    val columnSavings: String,
    val modeBaseline: String,
    val modeBaselineDescription: String,
    val modeMinimal: String,
    val modeMinimalDescription: String,
    val modeTesseractGate: String,
    val modeTesseractGateDescription: String,
    val modeTesseractOnly: String,
    val modeTesseractOnlyDescription: String,
)
